"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CaseComment = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
// React imports
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var ui_components_1 = require("@codametrix/ui-components");
var conditional_1 = require("../conditional/conditional");
var DEFAULT_PROPS = {
    title: 'Add case comment',
    minLength: 5,
    maxLength: 1024,
    numberOfRows: 4,
    submitLabel: 'Comment',
    mandatoryComment: true,
    actionOnlyNoComment: false
};
var CaseComment = /** @class */ (function (_super) {
    __extends(CaseComment, _super);
    /**
     * Constructor method for class CaseComment
     * @param {CMxCommonApp.CaseCommentProps} props - Props object passed to CaseComment component
     */
    function CaseComment(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            comment: '',
            validationMessage: ''
        };
        _this.handleCommentChange = _this.handleCommentChange.bind(_this);
        _this.submitComment = _this.submitComment.bind(_this);
        _this.cancelComment = _this.cancelComment.bind(_this);
        return _this;
    }
    /**
     * Method to handle the change event for text area element
     * @param {Object} event - Event object
     */
    CaseComment.prototype.handleCommentChange = function (event) {
        this.setState({ comment: event.target.value });
    };
    /**
     * Method to handle submit comment validation
     */
    CaseComment.prototype.handleValidation = function () {
        var comment = this.state.comment;
        if (this.props.mandatoryComment && (!comment || comment.trim() === '')) {
            this.setState({ validationMessage: 'Comment cannot be empty!' });
        }
        else if (comment.length < this.props.minLength) {
            this.setState({
                validationMessage: "Comment should have minimum ".concat(this.props.maxLength, " characters")
            });
        }
        return this.state.validationMessage ? false : true;
    };
    /**
     * Method to submit case comment
     */
    CaseComment.prototype.submitComment = function () {
        if (this.handleValidation()) {
            this.props.onSubmit(this.state.comment);
        }
    };
    /**
     * Method to cancel case comment
     */
    CaseComment.prototype.cancelComment = function () {
        this.props.onCancel();
    };
    CaseComment.prototype.render = function () {
        var _a;
        var props = __assign(__assign({}, DEFAULT_PROPS), this.props);
        var title = props.title, subtitle = props.subtitle, maxLength = props.maxLength, numberOfRows = props.numberOfRows, submitLabel = props.submitLabel, actionOnlyNoComment = props.actionOnlyNoComment;
        var validationMessage = this.state.validationMessage;
        var placeholder = (props.placeholder ? props.placeholder : 'Enter comments') +
            (props.mandatoryComment ? '' : ' (optional)');
        return ((0, jsx_runtime_1.jsx)(ui_components_1.Modal, __assign({ title: title, onClose: this.cancelComment }, { children: (0, jsx_runtime_1.jsxs)("form", __assign({ className: "case-comment", onSubmit: function (e) { return e.preventDefault(); } }, { children: [subtitle && (0, jsx_runtime_1.jsx)("p", __assign({ className: "case-comment-subtitle" }, { children: subtitle })), validationMessage && ((0, jsx_runtime_1.jsx)("p", __assign({ className: "case-comment-validation" }, { children: validationMessage }))), (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ every: [!actionOnlyNoComment] }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("textarea", { className: "case-comment-textarea form-input input", placeholder: placeholder, maxLength: maxLength, onChange: this.handleCommentChange, rows: numberOfRows }), (0, jsx_runtime_1.jsxs)("p", __assign({ className: "case-comment-length" }, { children: [(_a = this.state.comment) === null || _a === void 0 ? void 0 : _a.length, "/", maxLength] }))] }) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "case-comment-buttons-group" }, { children: [(0, jsx_runtime_1.jsx)("button", __assign({ onClick: this.cancelComment, className: "chakra-secondary-button" }, { children: "Cancel" })), (0, jsx_runtime_1.jsx)("button", __assign({ onClick: this.submitComment, className: (0, classnames_1["default"])('chakra-primary-button') }, { children: submitLabel }))] }))] })) })));
    };
    CaseComment.displayName = 'CaseComment';
    return CaseComment;
}(react_1["default"].Component));
exports.CaseComment = CaseComment;
//# sourceMappingURL=case-comment.js.map